import React, { useState, useEffect, useRef } from 'react';
import { Button, Row, Col, Form, Card } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { FaSyncAlt, FaPrint, FaEye, FaArrowLeft } from 'react-icons/fa';
import { BsFunnelFill, BsSearch, BsArrowClockwise, BsFileEarmarkText } from 'react-icons/bs';
import { LuGraduationCap } from 'react-icons/lu';
import ApiEndpoints, { BASE_URL, BASE_URL_Upload } from './commonComponents/ApiEndpoints';
import toast from 'react-hot-toast';
import Cookies from 'js-cookie'
import axios from 'axios';
import Image from 'react-bootstrap/Image'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { useParams, useLocation, useNavigate } from 'react-router-dom'

const DEFAULT_STUDENT_PHOTO = '/studentprofile.jpg'

const pickStudentImageRaw = (...candidates) => {
  for (const raw of candidates) {
    if (
      raw != null &&
      String(raw).trim() !== '' &&
      String(raw).toLowerCase() !== 'null' &&
      String(raw).toLowerCase() !== 'undefined'
    ) {
      return String(raw).trim()
    }
  }
  return ''
}

/** Use API student_image as-is (storage URLs are valid; /student/images/ rewrite 404s). */
const resolveStudentImageSrc = (raw) => {
  const picked = pickStudentImageRaw(raw)
  if (!picked) return DEFAULT_STUDENT_PHOTO
  let url = picked.replace(/^http:\/\//i, 'https://')
  if (url.startsWith('data:') || /^https?:\/\//i.test(url)) return url
  if (url.startsWith('//')) return `https:${url}`
  const base = String(BASE_URL_Upload || '').replace(/\/$/, '')
  const path = url.startsWith('/') ? url : `/${url}`
  return base ? `${base}${path}` : url
}

const Certificate = ({ hideFilters = false } = {}) => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const location = useLocation()
  const navigate = useNavigate()
  const routeParams = useParams()
  const student_id = routeParams.student_id || routeParams.studentId
  const course_id =
    routeParams.course_id ||
    routeParams.courseId ||
    location.state?.course_id ||
    location.state?.courseId
  const class_id =
    routeParams.class_id ||
    routeParams.classId ||
    location.state?.class_id ||
    location.state?.classId
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(!hideFilters)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

    const [courses, setCourses] = useState([])
    const [selectedCourseId, setSelectedCourseId] = useState('')
    const [selectedCourseName, setSelectedCourseName] = useState('')
  const [certificateData, setCertificateData]=useState("")
    const [selectedClass, setSelectedClass] = useState('')
  const [img, setImg] = useState(null)

  
    const [classes, setClasses] = useState([])
    const[allStududents, setAllStudents]=useState([])
    const [studentData, setStudentData] = useState({
      date: '',
      grade: '',
      certificateId: ''
    });    
    const [students, setStudents] = useState([])
    const [selectedStudent, setSelectedStudent] = useState('')
    const [selectedStudentInfo, setSelectedStudentInfo] = useState(null)
    const [showGenerateButton, setShowGenerateButton]= useState(true)
    const [errorMessageDuringGenerate, setErrorMessageDuringGenerate]=useState("")
    const [successMessageDuringGenerate, setSuccessMessageDuringGenerate]=useState("")
    const [instituteName, setInstitutename] = useState()
    
    const [openCertificate, setOpenCertificate] = useState(false)
    const [data, setData] = useState([])
    const [noCertificateFromProfile, setNoCertificateFromProfile] = useState(false)
    const [emptyStateToolbarDismissed, setEmptyStateToolbarDismissed] = useState(false)
    const [toolbarGenerateHiddenByRefresh, setToolbarGenerateHiddenByRefresh] =
      useState(false)
    const {token} = useAuth()
    const hasAutoFetched = useRef(false)
    const seededProfileParamsRef = useRef('')

    useEffect(()=>{
      const fetchAllStudent = async ()=>{
           try {
        const institueId = Cookies.get("institute_id")
        const userCookie = Cookies.get('user')

        if(!userCookie) {
          console.error("User cookie not found")
        }
        const user = JSON.parse(userCookie)
        const token = user.token

        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL + '/student/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)
        setAllStudents(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
      }
      fetchAllStudent()
    },[])

      useEffect(() => {
        const storedInstituteName = Cookies.get('institute_name')
    
        if (storedInstituteName) {
          console.log('Institute name:', storedInstituteName)
          setInstitutename(storedInstituteName)
        }
    
      }, [])
    

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => {
        console.log('Courses', res.data.data)
        setCourses(res.data.data)
      })
      .catch(console.error)
  }, [])

  // Auto-populate dropdowns when navigated from StudentProfile
  useEffect(() => {
    if (!(student_id && course_id && class_id && courses.length > 0)) return

    const paramsKey = `${student_id}:${course_id}:${class_id}`
    const isFirstSeed = seededProfileParamsRef.current !== paramsKey
    const student = allStududents.find((s) => s.id === Number(student_id))
    const fallbackStudent = student || { id: Number(student_id) }

    if (!isFirstSeed) {
      // Enrich student info once /student/all arrives; do not wipe certificate payload
      if (student) {
        setSelectedStudentInfo((prev) =>
          Number(prev?.id) === Number(student.id) ? { ...prev, ...student } : student,
        )
        setImg((prev) =>
          Number(prev?.id) === Number(student.id) ? { ...prev, ...student } : student,
        )
        // Typeahead reads from `students` — keep the selected row's name in sync
        setStudents((prev) => {
          const list = Array.isArray(prev) ? prev : []
          const idx = list.findIndex((s) => Number(s.id) === Number(student.id))
          if (idx === -1) return [...list, student]
          const next = [...list]
          next[idx] = { ...next[idx], ...student }
          return next
        })
        setData((prev) => {
          const list = Array.isArray(prev) ? prev : []
          const idx = list.findIndex((s) => Number(s.id) === Number(student.id))
          if (idx === -1) return [...list, student]
          const next = [...list]
          next[idx] = { ...next[idx], ...student }
          return next
        })
      }
      return
    }

    seededProfileParamsRef.current = paramsKey
    hasAutoFetched.current = false
    console.log('✅ useEffect triggered with params:')
    console.log('student_id:', student_id)
    console.log('course_id:', course_id)
    console.log('class_id:', class_id)

    // Seed from URL params so certificate can load even if
    // /student/all or by-class roster does not include this student yet.
    setSelectedCourseId(Number(course_id))
    setSelectedClass(Number(class_id))
    setSelectedStudent(String(student_id))
    setSelectedStudentInfo(fallbackStudent)
    setImg(fallbackStudent)
    setOpenCertificate(false)
    setNoCertificateFromProfile(false)

    const courseName = courses.find((c) => c.id === Number(course_id))
    if (courseName) {
      setSelectedCourseName(courseName)
    }

    ApiEndpoints.getAllClassesByCourseId(Number(course_id))
      .then((res) => {
        console.log('Classes fetched for course:', res.data.data)
        setClasses(res.data.data || [])
      })
      .catch((error) => {
        console.error('Error fetching classes:', error)
      })

    const institueId = Cookies.get('institute_id')
    const headers = {
      'institute-Id': Number(institueId),
      Authorization: token ? `Bearer ${token}` : undefined,
    }
    const mergeStudentFields = (...candidates) => {
      const merged = {}
      candidates.forEach((c) => {
        if (!c || typeof c !== 'object') return
        Object.entries(c).forEach(([k, v]) => {
          if (v !== undefined && v !== null && String(v).trim() !== '') {
            merged[k] = v
          }
        })
      })
      return merged
    }

    axios
      .get(BASE_URL + `/get/student/by-class?class_id=${class_id}`, { headers })
      .then((res) => {
        const list = Array.isArray(res.data?.data) ? res.data.data : []
        console.log('Students after class select:', list)
        const fromClass = list.find((s) => Number(s.id) === Number(student_id))
        const fromAll = allStududents.find((s) => Number(s.id) === Number(student_id))

        setStudents((prev) => {
          const prevList = Array.isArray(prev) ? prev : []
          const prevStudent = prevList.find(
            (s) => Number(s.id) === Number(student_id),
          )
          const studentInfo = mergeStudentFields(
            fallbackStudent,
            fromClass,
            fromAll,
            prevStudent,
          )
          const base = list.some((s) => Number(s.id) === Number(student_id))
            ? list
            : [...list, studentInfo]
          return base.map((s) =>
            Number(s.id) === Number(student_id)
              ? mergeStudentFields(s, studentInfo)
              : s,
          )
        })
        setData((prev) => {
          const prevList = Array.isArray(prev) ? prev : []
          const prevStudent = prevList.find(
            (s) => Number(s.id) === Number(student_id),
          )
          const studentInfo = mergeStudentFields(
            fallbackStudent,
            fromClass,
            fromAll,
            prevStudent,
          )
          const base = list.some((s) => Number(s.id) === Number(student_id))
            ? list
            : [...list, studentInfo]
          return base.map((s) =>
            Number(s.id) === Number(student_id)
              ? mergeStudentFields(s, studentInfo)
              : s,
          )
        })
        setSelectedStudentInfo((prev) =>
          mergeStudentFields(fallbackStudent, fromClass, fromAll, prev),
        )
        setImg((prev) =>
          mergeStudentFields(fallbackStudent, fromClass, fromAll, prev),
        )
      })
      .catch((error) => {
        console.error('Error fetching students:', error)
        const fromAll = allStududents.find(
          (s) => Number(s.id) === Number(student_id),
        )
        setStudents((prev) => {
          const prevList = Array.isArray(prev) ? prev : []
          const prevStudent = prevList.find(
            (s) => Number(s.id) === Number(student_id),
          )
          const studentInfo = mergeStudentFields(
            fallbackStudent,
            fromAll,
            prevStudent,
          )
          return prevList.some((s) => Number(s.id) === Number(student_id))
            ? prevList.map((s) =>
                Number(s.id) === Number(student_id)
                  ? mergeStudentFields(s, studentInfo)
                  : s,
              )
            : [...prevList, studentInfo]
        })
        setData((prev) => {
          const prevList = Array.isArray(prev) ? prev : []
          const prevStudent = prevList.find(
            (s) => Number(s.id) === Number(student_id),
          )
          const studentInfo = mergeStudentFields(
            fallbackStudent,
            fromAll,
            prevStudent,
          )
          return prevList.some((s) => Number(s.id) === Number(student_id))
            ? prevList.map((s) =>
                Number(s.id) === Number(student_id)
                  ? mergeStudentFields(s, studentInfo)
                  : s,
              )
            : [...prevList, studentInfo]
        })
        setSelectedStudentInfo((prev) =>
          mergeStudentFields(fallbackStudent, fromAll, prev),
        )
        setImg((prev) => mergeStudentFields(fallbackStudent, fromAll, prev))
      })
  }, [allStududents, student_id, course_id, class_id, courses, token])

  useEffect(() => {
    if (selectedCourseId) {
      ApiEndpoints.getAllClassesByCourseId(selectedCourseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            setClasses([])
          } else {
            setClasses(data.data)
            // setSelectedClass(classId)
          }
        })
        .catch(() => {
          setClasses([])
        })
    }
  }, [selectedCourseId])



    const handleCourseChange = async (e) => {
      const courseId = e.target.value
      setSelectedCourseId(courseId)
      console.log("Selected Course Id:", courseId)
      // setClasses([])
      // setFilteredStudents([])
      // setSelectedData([])
  
      if(courseId){
        const courseName = courses.find((c)=>c.id === Number(courseId))
        setSelectedCourseName(courseName)
      }
      if (courseId) {
        try {
          const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
          const { data } = res
          if (data?.status === false || !data?.data?.length) {
            toast.error(data?.message || 'No classes found for this course')
            setClasses([])
          } else {
            setClasses(data.data)
          }
        } catch (error) {
          const message = error?.response?.data?.message
          if (message === 'No classes found for this course') {
            toast.error(message)
          } else {
            console.error('Error fetching classes:', error)
            toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        }
      }
    }
    const handleClassChange = (e) => {
      // setHasModifiedFields(true)
      const classId = e.target.value
      console.log(' Targeted classId', classId)
      setSelectedClass(classId)

  
      if (classId) {
        const institueId = Cookies.get('institute_id')
        const headers = {
          'institute-Id': Number(institueId),
          Authorization: token ? `Bearer ${token}` : undefined,
        }
        axios
          .get(
            BASE_URL + `/get/student/by-class?class_id=${classId}`,
            { headers },
          )
          .then((res) => {
            console.log('Students after class select:', res.data.data)
            setData(res.data.data)
            setStudents(res.data.data)
            // setAllStudents(res.data.data)
          })
          .catch((error) => {
            // This is where 404 or other errors come
            if (
              error.response?.data?.message === 'No classes found for this course'
            ) {
              console.error('No classes found for this course.')
            } else {
              console.error('Error fetching classes:', error)
              console.error('Something went wrong while fetching classes.')
            }
            setClasses([])
          })
      }
    }


    toast.warning = (message) =>
  toast(message, {
    icon: '⚠️',
    style: {
      background: '#ff9800ow',
      color: 'black',
    },
  });

  const handleStudentChange = async (e) => {
    const studentId = e.target.value;
    setSelectedStudent(studentId);
  
    setOpenCertificate(false)
    setErrorMessageDuringGenerate(null)
    setShowGenerateButton(true)
    // Partial info (used for display, like name, class, etc.)
    const studentInfo = data.find((s) => s.id === Number(studentId));
    setSelectedStudentInfo(studentInfo);
    console.log('Selected student info:', studentInfo);
  
    // Full info (used to get admission_date)
    const fullInfo = allStududents.find((s) => s.id === Number(studentId));
    setImg(fullInfo)
    console.log('Full student info :', fullInfo);
      console.log('Full student info with father_name:', fullInfo?.father_name);
setCertificateData(fullInfo)
    if (fullInfo && fullInfo.admission_date) {
      // Format admission_date → 'YYYYMMDD'
      const rawDate = new Date(fullInfo.admission_date);
      // const datePart = rawDate.toISOString().slice(0, 10).replace(/-/g, ''); // e.g., '20250412'
  
      const datePart = rawDate.getFullYear()
      const coursePart = selectedCourseId || '00';
      const certificateId = `${datePart}/${coursePart}/${fullInfo.id}`;
  
      setStudentData({
        ...fullInfo, // Or use studentInfo if you prefer other display fields
        certificateId: certificateId,
        date: new Date().toLocaleDateString(), // today's date
        grade: fullInfo.grade || 'A',
      });
    } else {
      console.error('Admission date is not available for the selected student.');
    }
  
    // setOpenCertificate(true);
  };

//   const handleGenerateCertificate = async()=>{
//     if(!selectedCourseId){
//   toast.error("Please select a course before generating certificate.")
//   return 
// }

// try {


//   const checkResponse = await axios.get(`https://ttaapi.vibhumsoftware.com/api/certificate?student_id=${selectedStudent}&course_id=${selectedCourseId}`,
//      {
//       headers:{
//         Authorization:`Bearer ${token}`
//       }
//      })

//     console.log("Checking response of Certificate:", checkResponse)
//   const response = await axios.post( "https://ttaapi.vibhumsoftware.com/api/generate-certificate",{
//     student_id:selectedStudent,
//     course_id:selectedCourseId
//   },{
//     headers:{
//        "Content-Type": "application/json",
//        Authorization:`Bearer ${token}`
//     }
//   })
  
//   console.log(response.data)
//   if (
//         response.status === 201 &&
//         response.data.message === "Certificate generated successfully"
//       ) {
//         toast.success(response.data.message);
//         // keep button hidden after success
//         setShowGenerateButton(false);
//         setOpenCertificate(true)
//         setErrorMessageDuringGenerate(null)
//       } else if (
//         response.status === 200 &&
//         response.data.message === "Certificate already generated"
//       ) {
//         toast.warning(response?.data?.message);

//         setOpenCertificate(true)
//         setShowGenerateButton(false);
//         setErrorMessageDuringGenerate(null)
//       }
//       } catch (error) {
//         setErrorMessageDuringGenerate(error.response?.data?.error)
//         setOpenCertificate(false)
//       }
//     }

const handleGenerateCertificate = async () => {
  if (!selectedCourseId) {
    toast.error("Please select a course before generating certificate.");
    return;
  }

  try {
    const response = await axios.post(
      BASE_URL + "/generate-certificate",
      {
        student_id: selectedStudent,
        course_id: selectedCourseId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response while triger generate certificate button", response?.data)

    toast.success(response.data.message)
    // const {message, certificate, student, course, institute} = response.data

    // if (response.status===201 || response.data?.message === "Certificate generated successfully") {
    //   toast.success( response.data?.message );
    //   setOpenCertificate(true);
    //   setShowGenerateButton(false);
    // } else if (response.data.status===200 || response.data?.message === "Certificate already generated") {
    //   toast.info(response.data?.message );

    //   setShowGenerateButton(false); // Hide generate button
    // }
  } catch (error) {
    toast.error(error.response?.data?.error || "Something went wrong");
  }
};

const handleViewCertificate = async () => {
  if (!selectedCourseId) {
    toast.error("Please select a course before viewing certificate.");
    return;
  }

  if (!selectedStudent) {
    toast.error("Please select a student before viewing certificate.");
    return;
  }

  try {
    const response = await axios.get(
      BASE_URL + `/certificate?student_id=${selectedStudent}&course_id=${selectedCourseId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Certificate details fetched :", response.data)
    

      setCertificateData({
        certificate: response.data.certificate,
        student: response.data.student,
        course: response.data.course,
        institute: response.data.institute,
      });

      setOpenCertificate(true);
      setShowGenerateButton(false);
  } catch (error) {
    toast.error("Certificate not found. Please generate first.");
  }
};

  // Load full student profile photo (certificate API often omits student_image)
  useEffect(() => {
    if (!student_id) return
    let cancelled = false

    const loadStudentPhoto = async () => {
      const seedImage = pickStudentImageRaw(location.state?.studentImage)
      if (seedImage) {
        setImg((prev) => ({
          ...(prev || {}),
          id: Number(student_id),
          student_image: pickStudentImageRaw(prev?.student_image) || seedImage,
        }))
        setSelectedStudentInfo((prev) => ({
          ...(prev || {}),
          id: Number(student_id),
          student_image: pickStudentImageRaw(prev?.student_image) || seedImage,
        }))
      }

      try {
        const res = await ApiEndpoints.viewProfile(student_id)
        const profile = res?.data?.data || res?.data?.student || res?.data
        if (cancelled || !profile || typeof profile !== 'object') return

        const photo = pickStudentImageRaw(profile.student_image)
        const merged = {
          ...profile,
          id: Number(profile.id ?? student_id),
        }
        if (photo) merged.student_image = photo

        setImg((prev) => {
          const next = { ...(prev || {}), ...merged }
          if (!pickStudentImageRaw(merged.student_image)) {
            next.student_image =
              pickStudentImageRaw(prev?.student_image) || prev?.student_image || null
          }
          return next
        })
        setSelectedStudentInfo((prev) => {
          const next = { ...(prev || {}), ...merged }
          if (!pickStudentImageRaw(merged.student_image)) {
            next.student_image =
              pickStudentImageRaw(prev?.student_image) || prev?.student_image || null
          }
          return next
        })
        setCertificateData((prev) => {
          if (!prev || typeof prev !== 'object') return prev
          const existingPhoto = pickStudentImageRaw(prev?.student?.student_image)
          return {
            ...prev,
            student: {
              ...(prev.student || {}),
              ...merged,
              student_image: existingPhoto || photo || prev?.student?.student_image || null,
            },
          }
        })
      } catch (err) {
        console.warn('Failed to load student profile photo for certificate:', err)
      }
    }

    loadStudentPhoto()
    return () => {
      cancelled = true
    }
  }, [student_id, location.state?.studentImage])

  // Auto-fetch certificate when navigated from StudentProfile with params
  // (same pattern as ExamMarksheet: do not wait on by-class students list)
  useEffect(() => {
    const autoFetchCertificate = async () => {
      const matchesUrlParams =
        student_id &&
        course_id &&
        selectedStudent &&
        selectedCourseId &&
        Number(selectedStudent) === Number(student_id) &&
        Number(selectedCourseId) === Number(course_id)

      if (!matchesUrlParams || openCertificate || hasAutoFetched.current || !token) {
        return
      }

      console.log(
        'Auto-fetching certificate for student:',
        selectedStudent,
        'course:',
        selectedCourseId,
      )
      hasAutoFetched.current = true

      try {
        const response = await axios.get(
          BASE_URL +
            `/certificate?student_id=${selectedStudent}&course_id=${selectedCourseId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        console.log('Certificate details fetched :', response.data)

        const certStudent = response.data?.student
        setCertificateData((prev) => {
          const keptPhoto = pickStudentImageRaw(
            certStudent?.student_image,
            prev?.student?.student_image,
            location.state?.studentImage,
          )
          return {
            certificate: response.data.certificate,
            student: {
              ...(certStudent || {}),
              id: Number(certStudent?.id ?? selectedStudent),
              student_image: keptPhoto || certStudent?.student_image || null,
            },
            course: response.data.course,
            institute: response.data.institute,
          }
        })

        if (certStudent && (certStudent.name || certStudent.admission_number)) {
          const enriched = {
            ...certStudent,
            id: Number(certStudent.id ?? selectedStudent),
          }
          const mergeKeepImage = (prev) => {
            const next = { ...(prev || {}), ...enriched }
            if (!pickStudentImageRaw(enriched.student_image)) {
              next.student_image =
                pickStudentImageRaw(
                  prev?.student_image,
                  location.state?.studentImage,
                ) || prev?.student_image || null
            }
            return next
          }
          setSelectedStudentInfo((prev) => mergeKeepImage(prev))
          setImg((prev) => {
            const merged = mergeKeepImage(prev)
            const photo = pickStudentImageRaw(merged?.student_image)
            if (photo) {
              setCertificateData((certPrev) => {
                if (!certPrev || typeof certPrev !== 'object') return certPrev
                if (pickStudentImageRaw(certPrev?.student?.student_image)) {
                  return certPrev
                }
                return {
                  ...certPrev,
                  student: {
                    ...(certPrev.student || {}),
                    student_image: photo,
                  },
                }
              })
            }
            return merged
          })
          setStudents((prev) => {
            const list = Array.isArray(prev) ? prev : []
            const idx = list.findIndex((s) => Number(s.id) === Number(enriched.id))
            if (idx === -1) return [...list, enriched]
            const next = [...list]
            next[idx] = mergeKeepImage(next[idx])
            return next
          })
          setData((prev) => {
            const list = Array.isArray(prev) ? prev : []
            const idx = list.findIndex((s) => Number(s.id) === Number(enriched.id))
            if (idx === -1) return [...list, enriched]
            const next = [...list]
            next[idx] = mergeKeepImage(next[idx])
            return next
          })
        }

        setOpenCertificate(true)
        setShowGenerateButton(false)
        setNoCertificateFromProfile(false)
      } catch (error) {
        // Certificate not found - this is expected if it hasn't been generated yet
        console.log('Certificate not found. User can generate it if needed.')
        if (location.state?.fromStudentProfile || hideFilters) {
          setNoCertificateFromProfile(true)
        }
      }
    }

    const timer = setTimeout(() => {
      autoFetchCertificate()
    }, 300)

    return () => clearTimeout(timer)
  }, [
    student_id,
    course_id,
    selectedCourseId,
    selectedStudent,
    openCertificate,
    token,
    location.state,
    hideFilters,
  ])

  useEffect(() => {
    if (openCertificate) {
      setNoCertificateFromProfile(false)
    }
  }, [openCertificate])

  useEffect(() => {
    if (noCertificateFromProfile && !emptyStateToolbarDismissed) {
      setShowFilterCard(false)
    }
  }, [noCertificateFromProfile, emptyStateToolbarDismissed])

  useEffect(() => {
    setEmptyStateToolbarDismissed(false)
    setToolbarGenerateHiddenByRefresh(false)
  }, [student_id, course_id, class_id])

  const handleRefresh = () => {
    setSelectedCourseId('')
    setSelectedClass('')
    setSelectedStudent('')
    setData([])
    setStudents([])
    setOpenCertificate(false)
    setErrorMessageDuringGenerate('')
    setShowGenerateButton(true)
    setSelectedCourseName('')
    setImg(null)
    setCertificateData('')
    setSelectedStudentInfo(null)
    setStudentData({ date: '', grade: '', certificateId: '' })
    setClasses([])
    hasAutoFetched.current = false
    seededProfileParamsRef.current = ''
    if (location.state?.fromStudentProfile) {
      setToolbarGenerateHiddenByRefresh(true)
    }
  }

  useEffect(() => {
    const isBaseCertificateRoute =
      location.pathname === '/Certificate' || location.pathname === '/Certificate/'
    if (isBaseCertificateRoute) {
      setSelectedCourseId('')
      setSelectedClass('')
      setSelectedStudent('')
      setData([])
      setStudents([])
      setOpenCertificate(false)
      setErrorMessageDuringGenerate('')
      setShowGenerateButton(true)
      setSelectedCourseName('')
      setImg(null)
      setCertificateData('')
      setSelectedStudentInfo(null)
      setStudentData({ date: '', grade: '', certificateId: '' })
      setClasses([])
      setShowFilterCard(true)
      setNoCertificateFromProfile(false)
      setEmptyStateToolbarDismissed(false)
      setToolbarGenerateHiddenByRefresh(false)
      hasAutoFetched.current = false
      seededProfileParamsRef.current = ''
    }
  }, [location.pathname, location.key])

  const fromStudentProfile =
    !!location.state?.fromStudentProfile || hideFilters
  const isBaseCertificateRoute =
    location.pathname === '/Certificate' || location.pathname === '/Certificate/'
  const showNoCertMessage =
    fromStudentProfile &&
    noCertificateFromProfile &&
    !emptyStateToolbarDismissed
  const showToolbarGenerateButton =
    !hideFilters &&
    !isBaseCertificateRoute &&
    !(fromStudentProfile && openCertificate) &&
    !(
      fromStudentProfile &&
      noCertificateFromProfile &&
      emptyStateToolbarDismissed
    ) &&
    !(fromStudentProfile && toolbarGenerateHiddenByRefresh)
  // No Go Back on /student/:id/certificates/:course/:class (opened via list View)
  const showGoBackToolbar =
    !hideFilters && fromStudentProfile && student_id && !openCertificate

  const handleGoBackFromCertificate = () => {
    navigate(`/student/profile/${student_id}`)
  }

  const handleToolbarGenerateClick = () => {
    if (hideFilters) return
    setShowFilterCard(true)
    if (fromStudentProfile && noCertificateFromProfile) {
      setEmptyStateToolbarDismissed(true)
    }
  }

  useEffect(() => {
    if (hideFilters) {
      setShowFilterCard(false)
    }
  }, [hideFilters])

  // const studentName = "Bal Krishna"

  const spanStyle={
    width:"100%",
      borderBottom: "1px solid black",
      // minWidth: "390px",
      display: "flex",
      justifyContent: "space-between",
      // alignItems: "center",
      // fontWeight: "bold",
      // marginLeft: "1rem",
      // paddingBottom: "2px",
  }
  return (
    <>
      <style>
        {`
          .filter-card-container {
            overflow: visible !important;
            position: relative !important;
            z-index: 10 !important;
          }

          .rbt-menu {
            z-index: 1051 !important;
          }
        
    /* Watermark styles */
      .certificate-border {
        position: relative;
        background-color: white;
        overflow: hidden;
      }

.watermark-logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%);
  opacity: 0.12;
  z-index: 0;
  pointer-events: none;
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

.watermark-logo-wrapper img {
  width: 200%;       /* increase width only */
  height: auto;      /* keep height proportional */
  max-width: none;   /* prevent automatic limiting */
}


      /* Content stays above watermark */
      .certificate-content > * {
        position: relative;
        z-index: 1;
        margin-top: -2rem;
      }

          @media print {
          
            /* Hide filter section and non-printable controls */
            .no-print {
              display: none !important;
              visibility: hidden !important;
            }
          
            /* Hide sidebar and navigation completely */
            aside, nav, .sidebar, [class*="sidebar"], [class*="Sidebar"], 
            [class*="Sidenavbar"], [class*="sidenavbar"] {
              display: none !important;
              visibility: hidden !important;
              width: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
            }

            /* Reset ALL container divs that might have marginLeft or padding */
            div[style*="marginLeft"], 
            div[style*="margin-left"], 
            div[style*="paddingLeft"],
            div[style*="padding-left"],
            .container-fluid,
            .App > div,
            .App > div > div {
              margin-left: 0 !important;
              margin-right: 0 !important;
              padding-left: 0 !important;
              padding-right: 0 !important;
              width: 100% !important;
              max-width: 100% !important;
              left: 0 !important;
              transform: none !important;
            }

           
            /* Hide all elements by default */
            body * {
              // visibility: hidden;
            }

            .title-underline {
              display: block !important;
              height: 3px !important;
              background-color: #f1c40f !important;
              margin: 10px auto !important;
              border-bottom: 2px solid #f1c40f;
            }

            /* Show only certificate content */
            .certificate-printable, .certificate-printable * {
              visibility: visible;
            }
            
            .certificate-printable {
              position: absolute !important;
              left: 0 !important;
              top: 0 !important;
              margin-bottom: 0 !important;
              width: 100% !important;
              max-width: 100% !important;
              height: 100% !important;
              min-height: 100vh !important;
              margin-top: 0 !important;
              padding: 0 !important;
              transform: none !important;
            }

            /* Ensure certificate wrapper maintains centered layout with max-width */
            .certificate-wrapper {
              width: 100% !important;
              max-width: 100% !important;
              height: 100% !important;
              min-height: 100vh !important;
              margin: 0 auto !important;
              padding: 0 !important;
            }

            .certificate-border {
              width: 100% !important;
              height: 100% !important;
              min-height: 100vh !important;
              box-sizing: border-box !important;
            }

            html, body {
              width: 100% !important;
              height: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
            }
          }
        //         .watermark-logo-wrapper {
        //   opacity: 13 !important;
        //   width: 100% !important;
        // }
        
//         @media print {
//   .certificate-border {
//     border: 25px solid #4a6da7 !important;
//     background-color: white !important;
//     box-shadow: none !important;
//     print-color-adjust: exact;
//     -webkit-print-color-adjust: exact;
//     color-adjust: exact;
//   }

//   /* Ensure the wrapper is visible */
//   .certificate-wrapper {
//     visibility: visible !important;
//     position: relative !important;
//     print-color-adjust: exact;
//     -webkit-print-color-adjust: exact;
//   }
// }


            @page {
              size: A4 portrait;
              margin: 0mm;
            }
          }
          .certificate-wrapper {
            max-width: 1200px;
            margin: 0 auto;
            position: relative;
            width: 100%;
          }
          .certificate-border {
            background-color: white;
            border: 15px solid #4a6da7;
            position: relative;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
            print-color-adjust: exact;
            width: 100%;
            max-width: 100%;
          }
          
          /* Prevent certificate from responding to sidebar changes in UI view */
          .certificate-printable {
            position: relative;
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            isolation: isolate;
            left: auto !important;
            right: auto !important;
          }
          
          /* Ensure certificate elements maintain fixed positions and don't expand/collapse */
          .certificate-content {
            position: relative;
            width: 100%;
          }
          
          /* Prevent elements with inline marginLeft from being affected by parent */
          .certificate-content > div[style*="marginLeft"],
          .certificate-content > div[style*="margin-left"] {
            position: relative !important;
          }
          
          /* Prevent certificate from responding to sidebar changes in UI */
          .certificate-printable {
            position: relative;
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            isolation: isolate;
            left: auto !important;
            right: auto !important;
          }
          .corner {
            position: absolute;
            width: 50px;
            height: 50px;
          }
          .corner-tl {
            top: -3px;
            left: -5px;
          }
          .corner-tr {
            top: -5px;
            right: -5px;
            transform: rotate(90deg);
          }
          .corner-bl {
            bottom: -5px;
            left: -5px;
            transform: rotate(270deg);
          }
          .corner-br {
            bottom: -5px;
            right: -5px;
            transform: rotate(180deg);
          }
          .certificate-title {
            font-family: 'Times New Roman', serif;
            font-weight: bold;
            color: #2c3e50;
            font-size: 2.3rem;
            position: relative;
            display: inline-block;
          }
          .title-underline {
            width: 100px;
            height: 3px;
            background-color: #f1c40f;
            margin: 10px auto;
          }
          .student-name {
            // font-family: 'Brush Script MT', cursive;
            font-family: 'Lora', serif;
            font-weight: bold;
            font-size: 2.5rem;
            color: #2c3e50;
            margin: 1rem 0;
            position: relative;
            display: inline-block;
          }

           .student-name::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 2px;
            background: linear-gradient(90deg, transparent, #f1c40f, transparent);
    display: block;
    visibility: visible;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  
          .certificate-description {
            max-width: 700px;
            font-size: 1.6rem;
            line-height: 1;
          }
          .detail-item {
            // margin-bottom: 0.5rem;
          }
          .detail-label {
            font-weight: bold;
            margin-right: 0.5rem;
          }
          .signature-line {
            // width: 200px;
            // height: 1px;
            // background-color: #333;
            // margin: 0 auto;

              border-top: 1px solid #000;
  width: 150px;
  margin: 0 auto 8px auto;
          }
          .signature-name {
            font-weight: bold;
            margin-top: 10px;
          }

          
  
 
            
          .institution-logo img {
            border-radius: 50%;
            // border: 2px solid #f1c40f;
            // padding: 5px;
          }
          .print-button {
            background-color: #2c3e50;
            border: none;
            padding: 10px 25px;
            font-weight: bold;
          }
          .print-button:hover {
            background-color: #1a252f;
          }
          @media (max-width: 768px) {
            .certificate-title {
              font-size: 2rem;
            }

              
            .student-name {
              // font-size: 2.5rem;
            }
            .certificate-border {
              border-width: 10px;
            }
            .corner {
              width: 40px;
              height: 40px;
            }
          }
          @media (max-width: 576px) {
            .certificate-title {
              font-size: 1.8rem;
            }
            .student-name {
              font-size: 2rem;
            }
            .certificate-description {
              font-size: 1rem;
            }
            .signature-line {
              width: 150px;
            }
          }
 
       @media print {
  // .certificate-content img,
  // .certificate-content svg,
  // .certificate-content text {
  //   visibility: visible !important;
  // }

        // .certificate-border {
        //     background-color: white;
        //     border: 17px solid #4a6da7;
        // }

 .certificate-content svg {
    display: block !important;
    margin-left: auto !important;
    margin-right: auto !important;
    width:660px !important;
    margin-top:-4rem !important;
  }
    .certificate-content .img-tta{
          margin-left:0rem !important;
          margin-top:0rem !important;
          border-radius: 50% !important;
          object-fit: cover !important;
    }
 
           .certificate-content .img-style{
          // margin-right:2rem !important;
          margin-top:-2rem !important;
    }
    .certificate-content text{
    font-size:21px !important;
    margin-bottom:13rem !important;
  }
    
    /* Fix SVG text element (institute name) positioning in print view */
    .certificate-content svg text {
      font-size: 21px !important;
      font-weight: bold !important;
      fill: #2c3e50 !important;
    }
    
    /* Ensure the div containing SVG maintains proper positioning in print view */
    .certificate-content > div[style*="marginTop"][style*="-400"] {
      position: relative !important;
      margin-top: -400px !important;
      margin-left: 0 !important;
      width: 100% !important;
      height: 200px !important;
      display: flex !important;
      justify-content: center !important;
    }
    
    /* Ensure SVG maintains proper size and positioning */
    .certificate-content > div[style*="marginTop"][style*="-400"] svg {
      width: 900px !important;
      height: 1200px !important;
    }
}
@media print {
  .gof-nct {
    background-color: #4a6da7 !important;
    color: white !important;
    font-style: italic;
    font-size: 18px !important;
    border-radius: 2px !important;
    width: 10% !important;
    // max-width: 70% !important;
    // min-width: auto !important;
    margin-top:5.3rem !important;
    // padding: 2px !important;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  
  /* Override inline styles for print view */
  .certificate-content .gof-nct[style*="width"] {
    // width: 70% !important;
    margin-left: 6.5rem !important;
    max-width: 70% !important;
  }
  
  .gof-nct p {
    // padding: 5px !important;
    // margin: 0 !important;
  }
  
  /* Fix SVG text element (institute name) positioning in print view */
  .certificate-content svg {
    display: block !important;
    margin-left: auto !important;
    margin-right: auto !important;
    width:650px !important;
  }
  
  .certificate-content svg text {
    // font-size: 19px !important;
    // font-weight: bold !important;
    // fill: #2c3e50 !important;
  }
  
  .certificate-content > div[style*="marginTop"][style*="-400"] {
    // margin-top: -400px !important;
    // margin-left: -40px !important;
    // width: 100% !important;
    // height: 200px !important;
  }

.logo-box{
margin-top:14rem !important;
}
      .img-nct {
      margin-top:1rem !important;
            border-radius: 50%;
            // border: 2px solid #f1c40f;
            // padding: 5px;
              height: 90px !important;  /* smaller in print */
            width: 90px !important;
          }
      .gvt{
      font-size:8px !important;
      }
}

@media print {
  .row-signatures {
    margin-bottom: -2rem !important;
  }

  /* Fix bottom positioning when grade exists */
  .row-signatures.has-grade {
    margin-top: 4.7rem !important;
    // margin-bottom: 10px !important;
    // position: relative !important;
  }

  /* Keep same style when grade doesn't exist */
  .row-signatures.no-grade {
    margin-top: 8.6rem !important;
    // margin-bottom: -2rem !important;
  }
}

@media print {
  /* Fill full A4 page — remove bottom gap */
  html, body, #root, .App {
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
  }

  .certificate-printable,
  .certificate-wrapper,
  .certificate-border {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    min-height: 100vh !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .certificate-printable {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
  }

  /* Keep full watermark logo visible in print (no bottom clip) */
  .watermark-logo-wrapper {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 70% !important;
    height: auto !important;
    max-height: 70% !important;
    opacity: 0.12 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
  .watermark-logo-wrapper img {
    width: 100% !important;
    height: auto !important;
    max-height: 70vh !important;
    object-fit: contain !important;
  }
}


        `}
      </style>

      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0 no-print"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div 
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
              }}
            >
              {/* Left: Title */}
              <div className="d-flex align-items-center gap-3">
                {/* School Logo */}
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  overflow: 'hidden', 
                  background: '#223843',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  flexShrink: 0,
                }}>
                  {!logoError ? (
                    <img 
                      src={logo} 
                      alt="School Logo" 
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                
                <h3 
                  className="m-0 fw-bold" 
                  style={{ 
                    letterSpacing: '-0.02em',
                    overflow: 'visible',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#223843',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Generate Certificate
                </h3>
              </div>
                
              {/* Right: Profile Icon with Dropdown */}
              {!isMobile && (
                <ProfileDropdown logout={logout} />
              )}
            </div>
          </div>
        </div>

        {/* Non-printable controls */}
        <div className="no-print">
          <div
            className="container-fluid p-0 mt-4"
            style={{
              paddingLeft: isCollapsed ? '32px' : '40px',
              paddingRight: '32px',
              paddingTop: '32px',
              paddingBottom: '32px',
            }}
          >
            {/* Filter Toggle Button */}
            {showNoCertMessage && (
              <div
                className="mb-4 text-center"
                style={{
                  padding: '24px',
                  fontSize: '14px',
                  color: '#6b7280',
                  fontFamily: 'Inter, system-ui, sans-serif',
                }}
              >
                No certificate is available
              </div>
            )}

            <div
              className={`d-flex flex-wrap align-items-center gap-3 mb-4 ${
                hideFilters ? 'justify-content-end' : 'justify-content-between'
              }`}
            >
              <div
                className={`d-flex flex-wrap align-items-center gap-3 ${
                  hideFilters ? 'ms-auto' : ''
                }`}
              >
                {!hideFilters && (!noCertificateFromProfile || showFilterCard) && (
                  <button
                    onClick={() => setShowFilterCard(!showFilterCard)}
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                      border: '1px solid #D1D3D4',
                      color: showFilterCard ? '#ffffff' : '#223843',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                      e.currentTarget.style.color = '#ffffff'
                      e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                      e.currentTarget.style.transform = 'scale(1.05)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                      e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                      e.currentTarget.style.borderColor = '#D1D3D4'
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                    title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
                  >
                    <BsFunnelFill size={20} />
                  </button>
                )}
                {showGoBackToolbar && (
                  <div
                    className="d-none d-md-flex align-items-center gap-2"
                    style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                    onMouseEnter={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#059669'
                        button.style.borderColor = '#059669'
                        button.style.transform = 'scale(1.05)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1.05)'
                      }
                      e.currentTarget.style.transform = 'scale(1.02)'
                    }}
                    onMouseLeave={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#10B981'
                        button.style.borderColor = '#10B981'
                        button.style.transform = 'scale(1)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1)'
                      }
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                  >
                    <button
                      type="button"
                      onClick={handleGoBackFromCertificate}
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        border: '1px solid #10B981',
                        backgroundColor: '#10B981',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      title="Go Back"
                    >
                      <FaArrowLeft size={20} />
                    </button>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: '500',
                        transition: 'transform 0.2s ease',
                        display: 'inline-block',
                      }}
                    >
                      Go Back
                    </span>
                  </div>
                )}
                {hideFilters && openCertificate && selectedStudent && (
                  <div
                    className="d-none d-md-flex align-items-center gap-2"
                    style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                    onClick={() => window.print()}
                  >
                    <button
                      type="button"
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        border: '1px solid #223843',
                        backgroundColor: '#223843',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      title="Print Certificate"
                    >
                      <FaPrint size={20} />
                    </button>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: '500',
                      }}
                    >
                      Print Certificate
                    </span>
                  </div>
                )}
              </div>

              {showToolbarGenerateButton && (
              <button
                type="button"
                className="d-none d-md-flex align-items-center justify-content-center"
                onClick={handleToolbarGenerateClick}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Generate Certificate"
              >
                <BsFileEarmarkText size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Generate Certificate
                </span>
              </button>
              )}
            </div>

            <div
              className={`d-md-none d-flex align-items-center gap-3 mb-4 flex-wrap ${
                hideFilters
                  ? 'justify-content-end'
                  : showGoBackToolbar
                    ? 'justify-content-between'
                    : 'justify-content-end'
              }`}
            >
              {showGoBackToolbar && (
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                  onMouseEnter={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#059669'
                      button.style.borderColor = '#059669'
                      button.style.transform = 'scale(1.05)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1.05)'
                    }
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }}
                  onMouseLeave={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#10B981'
                      button.style.borderColor = '#10B981'
                      button.style.transform = 'scale(1)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1)'
                    }
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                >
                  <button
                    type="button"
                    onClick={handleGoBackFromCertificate}
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      border: '1px solid #10B981',
                      backgroundColor: '#10B981',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      flexShrink: 0,
                    }}
                    title="Go Back"
                  >
                    <FaArrowLeft size={20} />
                  </button>
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#111827',
                      fontFamily: 'Inter, system-ui, sans-serif',
                      fontWeight: '500',
                      transition: 'transform 0.2s ease',
                      display: 'inline-block',
                    }}
                  >
                    Go Back
                  </span>
                </div>
              )}
              {hideFilters && openCertificate && selectedStudent && (
                <button
                  type="button"
                  onClick={() => window.print()}
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    border: '1px solid #223843',
                    backgroundColor: '#223843',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    flexShrink: 0,
                  }}
                  title="Print Certificate"
                >
                  <FaPrint size={20} />
                </button>
              )}
              {showToolbarGenerateButton && (
              <button
                type="button"
                onClick={handleToolbarGenerateClick}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Generate Certificate"
              >
                <BsFileEarmarkText size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Generate Certificate
                </span>
              </button>
              )}
            </div>

            {/* Modern Filter Section — hidden on student certificates view route */}
            {!hideFilters && (
            <div 
              className="filter-card-container"
              style={{
                maxHeight: showFilterCard ? '1000px' : '0',
                overflow: showFilterCard ? 'visible' : 'hidden',
                transition: 'max-height 0.3s ease-in-out',
                marginBottom: showFilterCard ? '24px' : '0',
                position: 'relative',
                zIndex: showFilterCard ? 10 : 1,
              }}
            >
              {showFilterCard && (
                <Card 
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    overflow: 'visible',
                    position: 'relative',
                  }}
                  className="filter-card-container"
                >
                  {/* Header */}
                  <div 
                    style={{
                      background: '#ffffff',
                      padding: '20px',
                      borderBottom: '1px solid #F3F4F6',
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-3">
                        <div 
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#223843',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                        </div>
                        <div>
                          <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Search & Filter Certificate
                          </h5>
                          <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                            Select course, class, and student to generate certificate
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>

                  <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative' }}>
                    <Row className="g-4 text-start">
                      {/* Course Selection */}
                      <Col xs={12} md={4}>
                        <div style={{ position: 'relative' }}>
                          <Form.Group className="text-start fw-bold mb-0">
                            <Form.Label style={{ fontSize: '13px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif', marginBottom: '8px' }}>
                              Select Course
                            </Form.Label>
                            <Typeahead
                              id="course-select"
                              labelKey="name"
                              onChange={(selected) => {
                                const course = selected[0]
                                if (course) {
                                  handleCourseChange({ target: { value: course.id } })
                                } else {
                                  handleCourseChange({ target: { value: '' } })
                                }
                              }}
                              options={courses}
                              placeholder="Select Course"
                              selected={courses.filter(
                                (cs) => cs.id === Number(selectedCourseId || ''),
                              )}
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      {/* Class Selection */}
                      <Col xs={12} md={4}>
                        <div style={{ position: 'relative' }}>
                          <Form.Group className="text-start fw-bold mb-0">
                            <Form.Label style={{ fontSize: '13px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif', marginBottom: '8px' }}>
                              Select Class
                            </Form.Label>
                            <Typeahead
                              id="class-select"
                              labelKey="class_name"
                              onChange={(selected) => {
                                const cls = selected[0]
                                if (cls) {
                                  handleClassChange({ target: { value: cls.id } })
                                } else {
                                  handleClassChange({ target: { value: '' } })
                                }
                              }}
                              options={classes}
                              placeholder="Select Class"
                              selected={classes.filter(
                                (cs) => cs.id === Number(selectedClass || ''),
                              )}
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      {/* Student Selection */}
                      <Col xs={12} md={4}>
                        <div style={{ position: 'relative' }}>
                          <Form.Group className="text-start fw-bold">
                            <Form.Label style={{ fontSize: '13px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif', marginBottom: '8px' }}>
                              Select Student
                            </Form.Label>
                            <Typeahead
                              id="student-select"
                              labelKey={(option) => {
                                const name = option?.name || option?.student_name || ''
                                const adm =
                                  option?.admission_number || option?.admission_no || ''
                                if (name && adm) return `${name} - ${adm}`
                                return name || adm || `Student #${option?.id ?? ''}`
                              }}
                              onChange={(selected) => {
                                const student = selected[0]
                                if (student) {
                                  handleStudentChange({ target: { value: student.id } })
                                } else {
                                  handleStudentChange({ target: { value: '' } })
                                }
                              }}
                              options={students}
                              placeholder="Select Student"
                              selected={(() => {
                                const list = Array.isArray(students) ? students : []
                                const fromList = list.filter(
                                  (s) => Number(s.id) === Number(selectedStudent || ''),
                                )
                                if (fromList.length > 0 && (fromList[0]?.name || fromList[0]?.admission_number)) {
                                  return fromList
                                }
                                if (
                                  selectedStudentInfo &&
                                  Number(selectedStudentInfo.id) === Number(selectedStudent || '')
                                ) {
                                  return [selectedStudentInfo]
                                }
                                return fromList
                              })()}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                    </Row>

                    {/* Action Buttons Row */}
                    {selectedStudent && (
                      <Row className="mt-4">
                        <Col xs={12}>
                          <div className="d-flex align-items-center gap-3 flex-wrap">
                            {showGenerateButton && (
                              <div
                                className="d-flex align-items-center gap-2"
                                style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                                onMouseEnter={(e) => {
                                  const button = e.currentTarget.querySelector('button')
                                  const text = e.currentTarget.querySelector('span')
                                  if (button) {
                                    button.style.backgroundColor = '#059669'
                                    button.style.transform = 'scale(1.05)'
                                  }
                                  if (text) {
                                    text.style.transform = 'scale(1.05)'
                                  }
                                  e.currentTarget.style.transform = 'scale(1.02)'
                                }}
                                onMouseLeave={(e) => {
                                  const button = e.currentTarget.querySelector('button')
                                  const text = e.currentTarget.querySelector('span')
                                  if (button) {
                                    button.style.backgroundColor = '#10B981'
                                    button.style.transform = 'scale(1)'
                                  }
                                  if (text) {
                                    text.style.transform = 'scale(1)'
                                  }
                                  e.currentTarget.style.transform = 'scale(1)'
                                }}
                              >
                                <button
                                  onClick={handleGenerateCertificate}
                                  disabled={!selectedCourseId || !selectedStudent}
                                  style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '50%',
                                    border: '1px solid #10B981',
                                    backgroundColor: '#10B981',
                                    color: '#ffffff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: (!selectedCourseId || !selectedStudent) ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    flexShrink: 0,
                                    opacity: (!selectedCourseId || !selectedStudent) ? 0.5 : 1,
                                  }}
                                  title="Generate Certificate"
                                >
                                  <BsFileEarmarkText size={20} />
                                </button>
                                {!isMobile && (
                                  <span style={{ 
                                    fontSize: '14px', 
                                    color: '#111827', 
                                    fontFamily: 'Inter, system-ui, sans-serif', 
                                    fontWeight: '500',
                                    transition: 'transform 0.2s ease',
                                    display: 'inline-block',
                                  }}>
                                    Generate Certificate
                                  </span>
                                )}
                              </div>
                            )}

                            <div
                              className="d-flex align-items-center gap-2"
                              style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                              onMouseEnter={(e) => {
                                const button = e.currentTarget.querySelector('button')
                                const text = e.currentTarget.querySelector('span')
                                if (button) {
                                  button.style.backgroundColor = '#223843'
                                  button.style.transform = 'scale(1.05)'
                                }
                                if (text) {
                                  text.style.transform = 'scale(1.05)'
                                }
                                e.currentTarget.style.transform = 'scale(1.02)'
                              }}
                              onMouseLeave={(e) => {
                                const button = e.currentTarget.querySelector('button')
                                const text = e.currentTarget.querySelector('span')
                                if (button) {
                                  button.style.backgroundColor = '#223843'
                                  button.style.transform = 'scale(1)'
                                }
                                if (text) {
                                  text.style.transform = 'scale(1)'
                                }
                                e.currentTarget.style.transform = 'scale(1)'
                              }}
                            >
                              <button
                                onClick={handleViewCertificate}
                                disabled={!selectedCourseId || !selectedStudent}
                                style={{
                                  width: '48px',
                                  height: '48px',
                                  borderRadius: '50%',
                                  border: '1px solid #223843',
                                  backgroundColor: '#223843',
                                  color: '#ffffff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: (!selectedCourseId || !selectedStudent) ? 'not-allowed' : 'pointer',
                                  transition: 'all 0.2s ease',
                                  flexShrink: 0,
                                  opacity: (!selectedCourseId || !selectedStudent) ? 0.5 : 1,
                                }}
                                title="View Certificate"
                              >
                                <FaEye size={20} />
                              </button>
                              {!isMobile && (
                                <span style={{ 
                                  fontSize: '14px', 
                                  color: '#111827', 
                                  fontFamily: 'Inter, system-ui, sans-serif', 
                                  fontWeight: '500',
                                  transition: 'transform 0.2s ease',
                                  display: 'inline-block',
                                }}>
                                  View Certificate
                                </span>
                              )}
                            </div>

                            <div
                              className="d-flex align-items-center gap-2"
                              style={{ transition: 'all 0.2s ease', cursor: openCertificate ? 'pointer' : 'not-allowed' }}
                              onMouseEnter={(e) => {
                                if (openCertificate) {
                                  const button = e.currentTarget.querySelector('button')
                                  const text = e.currentTarget.querySelector('span')
                                  if (button) {
                                    button.style.backgroundColor = '#223843'
                                    button.style.transform = 'scale(1.05)'
                                  }
                                  if (text) {
                                    text.style.transform = 'scale(1.05)'
                                  }
                                  e.currentTarget.style.transform = 'scale(1.02)'
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (openCertificate) {
                                  const button = e.currentTarget.querySelector('button')
                                  const text = e.currentTarget.querySelector('span')
                                  if (button) {
                                    button.style.backgroundColor = '#223843'
                                    button.style.transform = 'scale(1)'
                                  }
                                  if (text) {
                                    text.style.transform = 'scale(1)'
                                  }
                                  e.currentTarget.style.transform = 'scale(1)'
                                }
                              }}
                            >
                              <button
                                onClick={() => window.print()}
                                disabled={!openCertificate || !selectedStudent}
                                style={{
                                  width: '48px',
                                  height: '48px',
                                  borderRadius: '50%',
                                  border: '1px solid #223843',
                                  backgroundColor: '#223843',
                                  color: '#ffffff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: (!openCertificate || !selectedStudent) ? 'not-allowed' : 'pointer',
                                  transition: 'all 0.2s ease',
                                  flexShrink: 0,
                                  opacity: (!openCertificate || !selectedStudent) ? 0.5 : 1,
                                }}
                                title="Print Certificate"
                              >
                                <FaPrint size={20} />
                              </button>
                              {!isMobile && (
                                <span style={{ 
                                  fontSize: '14px', 
                                  color: '#111827', 
                                  fontFamily: 'Inter, system-ui, sans-serif', 
                                  fontWeight: '500',
                                  transition: 'transform 0.2s ease',
                                  display: 'inline-block',
                                }}>
                                  Print Certificate
                                </span>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Card.Body>
                </Card>
              )}
            </div>
            )}
          </div>
        </div>

    {openCertificate && selectedStudent &&  (
        
        <div className="certificate-printable" style={{ 
          position: 'relative',
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          left: 'auto',
          right: 'auto',
          transform: 'none',
        }}>
            
          <div className="certificate-wrapper mt-4">
            
            <div className="certificate-border ">
              <div className="watermark-logo-wrapper">
                <img 
                  src={logo || Cookies.get('institute_logo') || '/certWatermark.jpg'} 
                  alt="Watermark Logo" 
                  className="watermark-logo"
                  onError={(e) => {
                    e.currentTarget.onerror = null
                    e.currentTarget.src = '/certWatermark.jpg'
                  }}
                />
              </div>
              <div className="corner corner-tl"></div>
              <div className="corner corner-tr"></div>
              <div className="corner corner-bl"></div>
              <div className="corner corner-br"></div>
              
              <div className="certificate-content p-4 p-md-5">
              
              
                    <div className="d-flex justify-content-between align-items-center">
                        <img 
                          src={logo} 
                          alt="Institution Logo" 
                          className="img-tta"
                          style={{ width: '100px',height:'100px', borderRadius: '50%', objectFit: 'cover' }}
                        />
                           {/* <Image
                            className="img-style"
                            src={
                              img?.student_image
                                ? img.student_image.replace(
                                    'https://ttaapi.vibhumsoftware.com/storage/student/',
                                    'https://ttaapi.vibhumsoftware.com/student/images/student/',
                                  )
                                : '/studentprofile.jpg'
                            }
                            style={{
                              width: '120px',
                              height: '120px',
                              border: '1px solid black',
                              background: 'white',
                            }}
                            onLoad={() => console.log('Image loaded')}
                          /> */}
                          <div className='text-center'>
                          <img 
                            src="/nct_logo2.png" 
                            alt="NCT Logo" 
                            className="img-nct"
                            style={{ width: '100px',height:'100px' }}
                          />
                           <div className='gvt' style={{ fontSize: '10px', fontWeight: 'bold', marginTop: '4px' }}>
                            GOVERNMENT OF NCT OF DELHI
                          </div>
                          </div>
                    </div>
  <div style={{ position: 'relative', 
  marginTop: -400, marginLeft: 0,
     width: "100%", height: "200px",
     display: 'flex', justifyContent: 'center' }}>
    <svg width="900" height="1200" viewBox="0 0 500 160" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', margin: '0 auto' }}>
      <defs>
        <path
          id="curve"
          d="M 25 135 A 240 270 0 0 1 475 135"
          fill="transparent"
        />
      </defs>
      <text fill="#2c3e50" fontSize="21px" fontWeight="bold">
        <textPath href="#curve" startOffset="50%" textAnchor="middle">
          {certificateData.institute?.institute_name?.toUpperCase()}
        </textPath>
      </text>
    </svg>
  </div>

  {/* <img 
    src="/nct_logo.png" 
    alt="NCT Logo" 
    className="img-nct"
    style={{ width: '120px' }}
  /> */}
                     
              {/* <div style={{marginTop:200}}>
                 <img 
                    src="/education-logo2.png" 
                    alt="NCT Logo" 
                    // className="img-nct"
                    style={{ width: '150px', }}
                  />               
              </div> */}

                <div style={{ marginTop: 250, display: 'flex', flexDirection: 'column', alignItems: 'center',marginBottom:"-2rem"}} className='logo-box'>
                  <img 
                    src="/education-logo3.png" 
                    alt="Education Logo" 
                    style={{ width: '100px' }} 
                  />

                  {/* <img
                    src="/nielit.png"
                    alt="NIELIT Logo"
                    style={{ width: '130px', height: '130px' }}
                  /> */}
                </div>

                <div className='gof-nct' style={{backgroundColor:"#4a6da7", color:"white", width:"50%" , fontSize:"20px", borderRadius:"2px", marginTop:85, marginLeft:280}}> 
                    <p style={{padding:5}}>Project Plan Conducted By Government of NCT of Delhi</p>
              </div>
                 <div className="text-center mb-3 pt-4 powered-by-footer" style={{marginTop:-40}}>
                  <small className="fw-bold powered" style={{ fontStyle: 'italic', fontSize: '14px', color:"#", }}>
                 Tera Tujko Arpan (ISO 9001 : 2015)
                </small>
                 <p className="fw-bold powered" style={{ fontSize: '14px', color:"#",letterSpacing:"1px", fontStyle: 'italic', }}>
                 UDYAM-DL-10-0079981
                </p>
              </div> 
                <div className="text-center" style={{ marginTop: -10,  }}>
                  <h2 className="certificate-title" style={{}}>Certificate of Achievement</h2>
                  <div className="title-underline mx-auto"></div>
                  <p style={{fontWeight:"600"}}>This Certificate is Awarded To</p>
                </div>
            <div
  className="certificate-header"
  style={{
    marginBottom: "60px",
    marginTop: '10px',
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position:"relative",
  }}
>

  {/* Center: Student Name */}
  <div style={{ 
    position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      width: "max-content", }}>
    <h2
      className="student-name"
      style={{ margin: 0, marginTop: "2rem", fontSize: "32px", fontWeight: "bold" }}
    >
      {certificateData?.student?.name}
    </h2>
  </div>

  {/* Right: Student Image */}
  <div style={{ flex: 1, textAlign: "right", }}>
    <Image
      className="img-style"
      src={resolveStudentImageSrc(
        pickStudentImageRaw(
          certificateData?.student?.student_image,
          img?.student_image,
          selectedStudentInfo?.student_image,
          location.state?.studentImage,
        ),
      )}
      onError={(e) => {
        if (e.currentTarget.src.endsWith(DEFAULT_STUDENT_PHOTO)) return
        e.currentTarget.onerror = null
        e.currentTarget.src = DEFAULT_STUDENT_PHOTO
      }}
      alt="Student"
      style={{
        width: "70px",
        height: "70px",
        border: "1px solid black",
        background: "white",
        objectFit: "cover",
      }}
    />
  </div>
</div>

     {/* Left: Certificate Number */}
  <div style={{ flex: 1, textAlign: "left" ,
    fontWeight:"bold"}}>
    <p style={{ marginTop:"-2rem", marginBottom:"10px", fontSize: "14px" }}>
      Certificate Number:{" "}
      <strong>{certificateData?.certificate?.certificate_number}</strong>
    </p>
  </div>         
              <div className="certificate-details text-start" style={{   fontWeight:"bold", marginTop:"12px"
              }}>
         <p style={{ display: "flex", alignItems: "center" }}>
          This certificate is awarded to
          <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>
            {certificateData?.student?.name || "\u00A0"}
          </span>
        </p>
      


              {/* <p>
                Son/Daughter of{" "}
                <span
                  style={{...spanStyle, minWidth:"460px"}}
                >
                  {certificateData.mother_name || "_______________________________"}
                </span>(Mother)
              </p> */}
              <p style={{ display: "flex", alignItems: "center" }}>
  Son/Daughter of{" "}(Father)
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    {certificateData?.student?.father_name || "\u00A0"}
  </span>
</p>

              {/* <p>
                and{" "}
                <span
                  style={{...spanStyle, minWidth:"560px"}}
                >
                  {certificateData.father_name || "__________________________"}
                </span>(Father)
              </p> */}
  <p style={{ display: "flex", alignItems: "center" }}>
                and{" "}(Mother)
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    {certificateData?.student?.mother_name || "\u00A0"}
  </span>
</p>

              {/* <p>
                 Admission number{" "}
                <span
                  style={{...spanStyle, minWidth:"320px"}}
                >
                  {selectedStudentInfo.admission_number || "__________________________"}
                </span>{" "}having completed the 
              </p> */}
  <p style={{ display: "flex", alignItems: "center" }}>
                 Admission number{" "}
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    {certificateData?.student?.admission_number || "\u00A0"}
  </span>
</p>
                {/* <p>
                Course on{" "}
                <strong> {selectedCourseName?.name} </strong>
              </p> */}
  <p style={{ display: "flex", alignItems: "center" }}>
                Course on{" "}
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    {certificateData?.course?.course_name || "\u00A0"}
  </span>
</p>
               {/* <p>
                during{" "}
                <span
                  style={{...spanStyle, minWidth:"430px"}}
                >
                  {" " || "__________________________"}
                </span>
              </p> */}
              <p style={{ display: "flex", alignItems: "center" }}>
                during{" "}
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" , marginTop: "0px"}}>   
   {new Date(certificateData.course.start_date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })} -{" "}
    {new Date(certificateData.course.end_date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }) || "\u00A0"}
  </span>
</p>
               {/* <p>
                The candidate is sponsored by{" "}
                <span
                  style={{...spanStyle, minWidth:"430px"}}
                >
                  {instituteName || "__________________________"}
                </span>
              </p> */}
  <p style={{ display: "flex", alignItems: "center" }}>
                The candidate is sponsored by{" "}
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    { certificateData?.institute?.institute_name || "\u00A0"}
  </span>
</p>
               {/* <p>
                 Candidate has been awarded{" "}
                <span
                  style={{...spanStyle, minWidth:"320px"}}
                >
                  {" " || "__________________________"}
                </span>{" "}Grade 
              </p> */}
             <p style={{ display: "flex", alignItems: "center" }}>
  Candidate has been awarded{" "}
  <span
    style={{
      flex: 1,
      borderBottom: "1px solid black",
      marginLeft: "8px",
      fontWeight: "bold",
      justifyContent: "center",
      display: "flex",
      marginTop: "18px"
    }}
  >
    {certificateData?.certificate?.grade || "\u00A0"}
  </span>{" "}
  Grade
</p>

              </div>           

            <div
  className={`row signatures row-signatures ${certificateData?.certificate?.grade ? 'has-grade' : 'no-grade'}`}
  style={{
    marginTop: "74px",
    marginBottom: "-1.8rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
    fontWeight:"bold"
  }}
>
  {/* Left: Issue Date */}
  <div style={{ flex: 2, textAlign: "left", }}>
    <p className="mb-0">Date of issue:</p>
    <p className="fw-bold">{certificateData?.certificate?.issue_date}</p>
  </div>

  {/* Center: Instructor */}
  <div style={{ flex: 7,  textAlign: "center" }}>
    <div className="signature-line mb-1"></div>
    <p className="mb-0">Instructor</p>
    <p className="signature-name">Authorized Signatory</p>
  </div>

  {/* Right: Director */}
  <div style={{ flex: 2, textAlign: "center" }}>
    <div className="signature-line mb-1"></div>
    <p className="mb-0">Director</p>
    <p className="signature-name">Authorized Signatory</p>
  </div>
            </div>

              </div>
                {/* <div className="text-center mt-0 mb-3 pt-4 powered-by-footer">
                  <small className="text-muted powered" style={{ fontStyle: 'italic', fontSize: '14px' }}>
                  Powered by <strong className='text-danger'>Tera Tujhko Arpan (ISO 9001 : 2015)</strong>
                </small>
              </div> */}
            </div>
          </div>
        </div>
        
    )}


    {errorMessageDuringGenerate  && !openCertificate && (
      <p className='text-danger fw-semibold mt-4'>{"There is no certificate available for this student. " +  errorMessageDuringGenerate}</p>
    )}
      </div>

    </>
  );
};

export default Certificate;


